module.exports = __webpack_public_path__ + "img/act-of-emotion-3-mobile.39cb6e53.jpg";